<template>
  <v-flex
    align-self-center
    justify-center
  >
    <v-container fill-height fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('create books')"
        @click="syncBook()"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("sync") }}
      </v-btn>
      <v-btn
        v-if="can('create books')"
        @click="showBookModal(0)"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("NEW") }}
      </v-btn>
      <v-btn
        v-if="can('import books')"
        :to="{ name: routeName.BOOK_IMPORT }"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("IMPORT") }}
      </v-btn>
      <v-btn
        v-if="can('export books')"
        @click="exportData()"
        dark
        class="mb-2"
      >{{ $t("EXPORT") }}
      </v-btn>
    </v-row>
    <v-row>
      <v-flex xs2 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH_BOOK_ISBN')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-flex xs2 class="mr-2">
        <Search
          v-model="filters.searchAuthor"
          :label="$t('SEARCH_AUTHOR')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-flex xs2 class="mr-2">
        <Search
          v-model="filters.searchVolume"
          :label="$t('SEARCH_VOLUME')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-flex xs2 class="mr-2">
        <Search
          v-model="filters.searchEditor"
          :label="$t('SEARCH_EDITOR')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
    </v-row>
    <v-row>

      <v-flex xs2 class="mr-2">
        <Search
          v-model="filters.searchSubject"
          :label="$t('SEARCH_SUBJECT')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>

      <v-flex xs2 class="mr-2">
        <Search
          v-model="filters.searchYear"
          :label="$t('SEARCH_YEAR')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>

      <v-flex xs2 class="mr-2">
        <Search
          v-model="filters.searchType"
          :label="$t('SEARCH_TYPE')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>

    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.isbn="{ item }">
        <router-link :to="{ name: routeName.BOOK_SHOW, params: { id: item.id } }">
            {{ item.isbn }}
        </router-link>
      </template>

      <template v-slot:item.title="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >{{ item.title }}  </span>
              </template>
              <span>{{item.title}}</span>
            </v-tooltip>
      </template>

      <template v-slot:item.editor="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >{{ item.editor | truncate(10, '') }}  </span>
              </template>
              <span>{{item.editor}}</span>
            </v-tooltip>
      </template>

      <template v-slot:item.type_id="{ item }">
            {{ item.type_id | truncate(3, '')}}
      </template>


      <template v-slot:item.subject="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >{{ item.subject | truncate(4, '') }}  </span>
              </template>
              <span>{{item.subject}}</span>
            </v-tooltip>
      </template>

      <template v-slot:item.degree="{ item }">
            <span v-if="item.options.is_primary">{{ $t('SM')}}</span>
            <span v-if="item.options.is_secondary" class="ml-1">{{ $t('SUP')}}</span>
      </template>

      <template v-slot:item.price="{ item }">
        {{ formatPrice(item.price) }}
      </template>

      <template v-slot:item.actions="{ item }">
            <v-layout wrap>
              <v-flex class="text-no-wrap">
                <v-btn
                  icon
                  color="blue"
                  v-if="can('edit books')"
                  @click="showBookModal(item.id)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  v-if="can('export books')"
                  icon
                  color="red"
                  @click="deleteBook(item.id)"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
    <div class="pt-2">{{$t('fields.total_items')}} {{ totalItems }}</div>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchBooks"
    />


  </v-flex>
</template>
<script>
  import { mapActions } from 'vuex';

  import { booksService } from '../../utils/services/books.service';
  import Search from '../../components/shared/Inputs/Search';
  import BookModal from '../../components/modals/Books/BookModal';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'BookList',
    components: { Search, Paginator },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        errorBag: {},
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['title'],
        },
        headers: [
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.author'), value: 'author' },
          { text: this.$t('fields.subject'), value: 'subject' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume', sortable: true },
          { text: this.$t('fields.year'), value: 'pubblication_year', sortable: true },
          { text: this.$t('fields.editor'), value: 'editor', sortable: true },
          { text: this.$t('fields.type'), value: 'type_id', sortable: true },
          { text: this.$t('fields.degree'), value: 'degree', sortable: false },
          { text: this.$t('fields.price'), value: 'price', sortable: false },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        filters: {
          search: null,
          searchAuthor: null,
          searchVolume: null,
          searchEditor: null,
          searchSubject: null,
          searchYear: null,
          searchType: null,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
          search_author: this.filters.searchAuthor,
          search_volume: this.filters.searchVolume,
          search_editor: this.filters.searchEditor,
          search_subject: this.filters.searchSubject,
          search_year: this.filters.searchYear,
          search_type: this.filters.searchType,

        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      async fetchBooks(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return booksService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      formatPrice(price) {
        return new Intl.NumberFormat('en-IT', {
              style: 'currency',
              currency: 'EUR',
          }).format(price);
      },

      exportData() {
        this.loading = true;
        return booksService.exportData({
          filters: this.requestFilters,
        })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'books.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async showBookModal(id) {
        this.showModal({
          component: BookModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('BOOK'),
            onSave: (
              form,
              errorBag,
            ) => booksService.save(form)
            .then(() => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch((error) => {
              this.handleError(error, errorBag);
            })
            .finally(() => {
              this.fetchBooks(this.pagination.page);
            }),
          },
        });
      },

      async syncBook() {
          this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return booksService.syncBooks()
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('SYNCRONIZED') });
                this.fetchBooks(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },

      async deleteBook(id) {
          this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return booksService.remove(id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchBooks(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
    },
    async created() {
      await this.fetchBooks(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchBooks(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchBooks(1);
          }
        },
      },

    },
  };
</script>
